import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import BoxWhite from 'components/BoxWhite';
import Image from 'components/Image';
import Link from 'components/Link';
import PageTitle from 'components/PageTitle';
import PageContainer, { Wrap } from 'components/PageContainer';
import Layout from 'components/Layout';
import Markup from 'components/Markup';
import i18n from 'i18n';
import prismic from '../prismic';
import { fetchPress } from 'actions/prismic';

class Press extends Component {
  static async getInitialProps({ store, req, lang, prismicRef }) {
    return store.dispatch(fetchPress({ lang, prismicRef }));
  }

  render() {
    const { press, ...rest } = this.props;
    const { name, description, items, meta, ...other } = prismic.press(press);
    return (
      <Layout {...other} {...rest} meta={meta}>
        <PageContainer>
          <PageTitle center>{name}</PageTitle>
          <Wrap>
            <Markup>{description}</Markup>
          </Wrap>
          {items.map((item, index) => (
            <BoxWhite
              className="my-0 my-sm-5 px-2 py-4 p-sm-5 border-bottom"
              key={index}>
              <div className="container">
                <div className="row">
                  <div className="col-md-2 offset-md-1">
                    <Image
                      className="img-fluid mx-auto d-block"
                      style={{ maxHeight: 150 }}
                      src={item.imageUrl}
                      alt={item.name}
                    />
                  </div>
                  <div className="col-md-8">
                    <h3 className="text-muted">{item.name}</h3>
                    <p className="text-muted">
                      {moment(item.date).format('MMM YYYY')}
                    </p>
                    {!!item.linkUrl && (
                      <Link
                        route={item.linkUrl}
                        target="_blank"
                        className="btn btn-outline-primary">
                        {i18n.t('READ_MORE')}
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </BoxWhite>
          ))}
        </PageContainer>
      </Layout>
    );
  }
}

Press.propTypes = {
  press: PropTypes.object
};

export default connect(({ prismic }) => ({
  press: prismic.press
}))(Press);
